<template>
	<div class="menu-item-picker" :class="{ 'is-active': editor.isActive('bold') }" @click="onClick">
		<BoldSvg />
	</div>
</template>

<script>
import BoldSvg from './assets/BoldSvg';

export default {
	name: 'BoldFormatting',
	components: {
		BoldSvg,
	},
	props: {
		editor: { type: Object },
	},
	methods: {
		onClick() {
			this.editor.chain().focus().toggleBold().run();
		},
	},
};
</script>

<style lang="scss" scoped></style>
